export class ReceiptType {
  static readonly INTERNAL = "internal";
  static readonly ADAMS_FREIGHT_HANDLING = "adams_freight_handling";
}

export class UserShift {
  static readonly SHIFT_1 = "1st Shift";
  static readonly SHIFT_2 = "2nd Shift";
  static readonly SHIFT_3 = "3rd Shift";

  static selectOptions = () => {
    const keys = Object.keys(UserShift).filter((k) => k !== "selectOptions");

    const options = keys.map((s) => {
      return {
        value: UserShift[s],
        label: UserShift[s],
      };
    });

    options.unshift({
      value: null,
      label: "- Without Shift -",
    });

    return options;
  };
}

export enum ProducTab {
  PRODUCTS = "products",
  GROUPS = "groups",
  CATEGORIES = "categories",
}

export class ProductTabs {
  static labelsDict = (type: ProducTab) => {
    const mapping = {
      [ProducTab.PRODUCTS]: "Products",
      [ProducTab.GROUPS]: "Groups",
      [ProducTab.CATEGORIES]: "Categories",
    };

    return mapping[type];
  };

  static routesDict = {
    [ProducTab.PRODUCTS]: "pos.admin.products.all-products",
    [ProducTab.GROUPS]: "pos.admin.products.groups",
    [ProducTab.CATEGORIES]: "pos.admin.products.categories",
  };

  static options = () => {
    const keys = [ProducTab.PRODUCTS, ProducTab.GROUPS, ProducTab.CATEGORIES];

    return keys.map((key) => {
      return {
        label: ProductTabs.labelsDict(key),
        route: ProductTabs.routesDict[key],
        key,
      };
    });
  };
}

export enum ProductSegmentType {
  GROUP = "group",
  CATEGORY = "category",
}

export enum ProductTypes {
  ITEM = "Item",
  SERVICE = "Service",
  CUSTOM = "Custom",
  ITEM_NOT_DROPDOWN = "ItemNotDropdown",
}
export class ProductTypeOptions {
  static labelsDict = () => ({
    [ProductTypes.ITEM]: "Select Quantity (1-50)",
    [ProductTypes.SERVICE]: "Apply Fee (Yes/No Choice)",
    [ProductTypes.CUSTOM]: "Enter Custom Price",
    [ProductTypes.ITEM_NOT_DROPDOWN]: "Enter Quantity Manually",
  });

  static selectOptions = () => {
    const labels = ProductTypeOptions.labelsDict();
    return Object.keys(labels).map((key: ProductTypes) => ({
      value: key,
      label: labels[key],
    }));
  };
}